"use client";
import React, { useState } from "react";
import ShareButton from "../component/ShareButton";
import ShareModal from "../../../pages/Neighborhood/ShareModal";

/**
 * Client component wrapper for share button functionality
 * Manages modal state for SSR component
 */
export default function ShareButtonWrapper() {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const handleShareButtonClick = () => {
    setIsShareModalOpen(true);
  };

  const handleCloseShareModal = () => {
    setIsShareModalOpen(false);
  };

  return (
    <div className="share-button-container nhranking-share-button">
      <ShareButton onClick={handleShareButtonClick} />
      <ShareModal
        isShareModalOpen={isShareModalOpen}
        handleCloseShareModal={handleCloseShareModal}
      />
    </div>
  );
}
